export default __webpack_public_path__ + "static/media/5insta.6b26ed2e.jpg";